import { createTranslatior } from 'libs/i18n';

import { translationResources } from './availableLanguages';

export const text = createTranslatior({ resources: translationResources, defaultLangue: 'en' });
export const textIgnoreCase = createTranslatior({ resources: translationResources, defaultLangue: 'en' });
